import { ADMIN_BASE_URL, BASE_URL, MOBILE_BASE_URL } from "../api_const"

export const QUOTATION_REQUESTS_URL = BASE_URL + "/quotation/request"

export const CREATE_QUOTATION_REQUESTS = QUOTATION_REQUESTS_URL + "/create" 
export const UPDATE_QUOTATION_REQUESTS = QUOTATION_REQUESTS_URL + "/update" 
